module.exports = __webpack_public_path__ + "static/media/lxl.bd3504ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/AntD/assets/img/displayBoard/lxl.svg
// module id = 4476
// module chunks = 0